import React, { FC } from 'react';

import styled from 'styled-components';

import BlockRenderer from 'components/sanity-block-renderer';

import { INutritionDisclaimer } from '../types';

const Disclaimer = styled(BlockRenderer)`
  margin: 1rem 0;
  padding: 0;
  color: ${Styles.color.grey.one};
  font-style: normal;
  font-size: 0.75rem;
  font-family: ${Styles.fontFamily.body};
  overflow: visible;

  a {
    color: ${Styles.color.grey.one};
  }
`;

export const NutritionDisclaimer: FC<INutritionDisclaimer> = ({ content }) => (
  <Disclaimer data-testid="nutrition-disclaimer" content={content} />
);
